// @ts-strict-ignore
import {Event, SearchOperator, SimUser} from "@models";

export type SearchableColumn = DefaultSearchableColumn | SelectColumn | MultiSelectColumn;

type SharedSearchableColumnProps = {
	value: string;
	displayName: string;
	exactMatch?: boolean;
	searchOperator?: SearchOperator;
};

export type DefaultSearchableColumn = SharedSearchableColumnProps & {
	type: "FreeText" | "Checkbox" | "Date" | "User" | "Event";
};

export type MultiSelectColumn = SharedSearchableColumnProps & {
	icon: string;
	type: "MultiSelect";
	selectableOptions: SelectableOption[];
};

export type SelectColumn = SharedSearchableColumnProps & {
	type: "Select";
	selectableOptions: SelectableOption[];
};

export type SelectableOption = {value: string; translationToken: string};

export function convertSearchableColumnToSearchTerm(type: SearchableColumn["type"], rawValue: Object): string {
	if (type === "Checkbox") {
		return rawValue.toString();
	} else if (type === "Date" && rawValue instanceof Date && !isNaN(rawValue.getTime())) {
		let year = rawValue.getFullYear();
		let month = String(rawValue.getMonth() + 1).padStart(2, "0");
		let day = String(rawValue.getDate()).padStart(2, "0");
		return `${year}-${month}-${day}`;
	} else if (type === "User") {
		return (rawValue[0] as SimUser)?.id;
	} else if (type === "Event") {
		return (rawValue[0] as Event)?.id;
	} else {
		return rawValue.toString();
	}
}
